import React from 'react';
import Modal from 'Components/Modal';
import { toggleSystemModal, setHRBetslipSystem, verifyTJKCoupon } from 'Store/actions/horseRacing/betSlipActions';
import { classnames } from 'Utils/classnames';
import { useDispatch, useSelector } from 'react-redux';
import EnvironmentManager from 'Utils/environmentManager';
import { withMixpanel } from 'Utils/mixpanel';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import { useHRBetslipSystem } from 'Utils/hooks/useHRBetslipSystem';

const SystemSelect = ({ mixpanel }) => {
  const dispatch = useDispatch();
  const { systemSelected } = useHRBetslipSystem();
  const betSlip = useSelector(state => state.horseRacing.betSlip);

  const { footerData, combinedHorses, showSystemModal, verify } = betSlip;
  const verifyData = verify?.data?.body || {};
  const verifyErrorData = verify?.error?.extras || {};
  const { system } = footerData;
  const systemAllowed = verifyData?.systemAllowed || verifyErrorData?.systemAllowed;
  const column = verifyData?.column  || verifyErrorData?.column;

  const onItemClick = (item, isSelected) => {
    if (combinedHorses?.length === 1) return;
    let data;
    if (isSelected) {
      if (system?.length === 1 && system[0] === combinedHorses?.length) return;
      if (system?.length === 1) {
        data = [combinedHorses?.length];
      } else  {
        data = system.filter(e => e !== item);
      }
    } else {
      data = [...system, item];
    }
    dispatch(setHRBetslipSystem(data));
    dispatch(verifyTJKCoupon());
  };

  const onApply = () => {
    dispatch(toggleSystemModal(false));
    mixpanel.track('TJK Click Apply on System Selection', {
      BetCount: combinedHorses?.length || 0,
      SelectedSystems: systemSelected ? system?.join(',') : '-',
      ColumnCount: column || '-',
    });
  };

  const buttonArea = {};

  if (systemAllowed) {
    buttonArea.primaryButton = {
      label: 'UYGULA',
      onClick: onApply,
    };
  } else {
    buttonArea.secondaryButton = {
      label: 'Kapat',
      onClick: () => {
        dispatch(toggleSystemModal(false));
      }
    };
  }

  return (
    <Modal
      isOpen={ showSystemModal !== undefined && showSystemModal }
      title={ systemAllowed ? 'Sistem Seçimi' : null }
      centered
      className="hr-system-select-modal"
      modalSize="normal"
      buttonArea={ buttonArea }
      onClose={ () => dispatch(toggleSystemModal(false)) }>
      <div className="hr-system-select">
        {
          systemAllowed ? <>
            <div className="hr-system-select__list">
              {
                Array.from({ length: combinedHorses?.length }, (_, index) => {
                  const isSelected = system?.includes(index + 1);
                  return (
                    <div onClick={ () => onItemClick(index + 1, isSelected) } key={ index } className={ classnames({
                      'hr-system-select__list-item': true,
                      selected: isSelected
                    }) }>
                      { index + 1 }
                    </div>
                  );
                })
              }
            </div>
            <div className="hr-system-select__column-count">
              Kolon Sayısı: <span>{ column }</span>
            </div>
          </> : <div className="hr-system-select__info">
            <div className="hr-system-select__info-text">
              <Icon iconName="svgInfoModal"/>
              <h1>{ EnvironmentManager.getMessageText({ key: 'v1.system.exceed_bet_title' }) }</h1>
              <p>{ EnvironmentManager.getMessageText({ key: 'v1.system.exceed_bet_description' }) }</p>
            </div>
          </div>
        }
      </div>
    </Modal>
  );
};

SystemSelect.propTypes = {
  mixpanel: PropTypes.object
};

export default withMixpanel(SystemSelect);
